import { createFileRoute, notFound } from "@tanstack/react-router";

import { LeadMagnetView } from "@/components/pages/LeadMagnetView";
import { landingMagnets } from "@/content/landing-magnets";
import { isLocale } from "@/i18n/locales";
import { seoHead } from "@/lib/site";

export const Route = createFileRoute("/$locale/vaccination-checklist")({
  head: ({ params }) =>
    isLocale(params.locale)
      ? seoHead({
          locale: params.locale,
          path: "/vaccination-checklist",
          ...landingMagnets[params.locale].vaccinationChecklist.meta,
          smartBanner: true,
        })
      : {},
  component: VaccinationChecklistRoute,
});

function VaccinationChecklistRoute() {
  const { locale } = Route.useParams();
  if (!isLocale(locale)) throw notFound();
  return <LeadMagnetView locale={locale} page="vaccinationChecklist" />;
}
